var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcademicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43958 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43958 31.5 16Z",
    fill: "white",
    stroke: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2256 13.87C13.4765 13.7822 11.2407 14.2478 11.2316 14.9095L11.1778 18.8918C11.1687 19.5534 13.3904 20.1607 16.1395 20.2485C18.8886 20.3363 21.1244 19.8706 21.1335 19.209L21.1873 15.2267C21.1964 14.5651 18.9747 13.9578 16.2256 13.87Z",
    fill: "#190D1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92773 14.6164L16.6795 12.3438L25.5652 14.7428L16.3685 17.9122L6.92773 14.6164Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35932 19.9862C9.33836 19.9868 9.31742 19.98 9.2993 19.9641C9.25738 19.9273 9.24829 19.8582 9.27888 19.8101C9.96148 18.7366 9.10498 15.4703 9.09591 15.4375L9.0625 15.3123L16.6651 14.2303C16.7172 14.2229 16.7642 14.266 16.7716 14.3266C16.7784 14.3872 16.7422 14.4422 16.6906 14.4495L9.30892 15.4998C9.46583 16.1314 10.098 18.8946 9.43126 19.9426C9.4137 19.9704 9.38707 19.9851 9.35932 19.9862Z",
    fill: "#FBB03B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6918 14.6025C16.9366 14.5933 17.1306 14.4666 17.125 14.3197C17.1195 14.1728 16.9165 14.0611 16.6718 14.0704C16.427 14.0796 16.233 14.2062 16.2386 14.3532C16.2441 14.5001 16.447 14.6117 16.6918 14.6025Z",
    fill: "#190D1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18216 19.9121C8.58057 20.2673 9.02921 20.8428 8.75391 21.164C9.74353 20.806 9.41896 20.0707 9.41896 20.0707L9.18216 19.9121Z",
    fill: "#FBB03B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50681 19.8987L9.26661 19.7373L9.18164 19.9123L9.42184 20.0738L9.50681 19.8987Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicIcon);
export default __webpack_public_path__ + "static/media/AcademicIcon.6d64199f5946f49e109339592b3a8da4.svg";
export { ForwardRef as ReactComponent };